'use strict';

var PooledCalendarFactory = function PooledCalendarFactory(seasonalityConstants, momentService, configurationService) {
  /**
   * Creates new pooled seasonality calendar object
   * @param calendar
   * @constructor
   */
  function PooledCalendar(calendar) {
    var hep = configurationService.getHepMap();
    calendar = calendar || {};
    var metrics = seasonalityConstants.POOLED_SEASONALITY_METRICS;

    /**
     * Metric
     * @type {string}
     */
    this.metric = metrics[0].id;

    /**
     * An array of markets associated with this calendar
     * @type {Array.string}
     */
    this.markets = calendar.markets || [];
    this.selectedMarkets = calendar.selectedMarkets || [];

    /**
     * Calendar name (?)
     * @type {*|string}
     */
    this.name = calendar.name || '';

    /**
     * Date range start MomentFactory
     * @type {MomentFactory}
     */
    this.dateRangeFrom = calendar.dateRangeFrom || momentService.systemNow(momentService.FIELD.SEASONALITY_DATE_RANGE).subtract(52, 'weeks');

    /**
     * Date range end MomentFactory
     * @type {MomentFactory}
     */
    this.dateRangeTo = calendar.dateRangeTo || momentService.systemNow(momentService.FIELD.SEASONALITY_DATE_RANGE).subtract(1, 'days');

    /**
     * Outlier Tolerance
     * @type {Document.clusteringParams.outlierTolerance|number}
     */
    this.outlierTolerance = calendar.outlierTolerance || parseFloat(hep.SEASONALITY_OUTLIER_TOLERANCE);

    /**
     * Learning Process
     * @type {string}
     */
    this.learningProcess = calendar.learningProcess || seasonalityConstants.LEARNING_PROCESSES[0];

    /**
     * Regression Terms
     * @type {*|number}
     */
    this.regressionTerms = calendar.regressionTerms || {
      id: 5
    };

    /**
     * A list of DOW Groups.
     * @type {Array.DowGroup}
     */
    this.dowGroups = calendar.dowGroups || [];

    /**
     * A list of Events.
     * @type {Array.Event}
     */
    this.events = calendar.events || [];
  }
  return PooledCalendar;
};
PooledCalendarFactory.$inject = ['SeasonalityConstants', 'MomentService', 'ConfigurationService'];
module.exports = PooledCalendarFactory;